import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lottery-details',
  templateUrl: './lottery-details.component.html',
  styleUrls: ['./lottery-details.component.scss'],
})
export class LotteryDetailsComponent implements OnInit {
  title = 'app-lottery-details';

  ngOnInit(): void {}
}
